// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

// is User admin of the current company
export const isUserAdmin = state => {
  const companyUuid = state.companies.company?.company_uuid;
  const memberships = state.user.user?.company_memberships;

  if (!companyUuid || !memberships) {
    return false;
  }

  return memberships.some(m => m.company_uuid === companyUuid && m.company_role === 'admin');
};

export const currentUser = state => {
  return state.user.user;
};

export const currentUserUuid = state => {
  return state.user.user?.user_id;
};

// user permission in the current company
export const userPermission = state => {
  const companyUuid = state.companies.company?.company_uuid;
  const memberships = state.user.user?.company_memberships;

  if (!companyUuid || !memberships) {
    return null;
  }
  return memberships.find(m => m.company_uuid === companyUuid)?.company_role || null;
};

// is User member of the current studio
export const isStudioMember = state => {
  const studioMembers = state.studios.studio?.members || [];
  const userId = state.user.user?.user_id;

  if (!userId || studioMembers.length === 0) {
    return false;
  }

  return studioMembers.some(member => member?.company_member?.user_id === userId);
};

const isExpired = expiresAt => {
  if (!expiresAt) {
    return false;
  }
  // TODO: update to get the system server time instead of client time
  const now = new Date();
  const expiryDate = new Date(expiresAt);
  return expiryDate < now;
};

export const userPendingInvitations = state => {
  const invites = state.user?.user?.invites || [];
  return invites.filter(el => {
    const expiredInvite = isExpired(el.expires);
    const isValid = el.decision === null && el.revoked === false;
    return !expiredInvite && isValid;
  });
};

export const userPendingLockRequests = state => {
  const notifications = state.user?.notifications || [];
  // TODO this would be faster if the backend provided the full lock object
  // in the lockrequest...
  return notifications.filter(el => {
    const lockedGroup = state.equipment?.equipmentGroups?.find(
      eg => eg?.lock?.length > 0 && eg.lock[0].lock_uuid === el?.lock_uuid
    );
    return lockedGroup?.lock[0]?.company_member?.user_id === currentUserUuid(state);
  });
};

export const pendingLockRequest = state => {
  const notifications = state.user?.notifications || [];
  return notifications.find(el => el?.company_member?.user_id === currentUserUuid(state));
};

// Returns the status and variant for a given invitation
// possible status values: 'pending', 'accepted', 'declined', 'revoked', 'expired'
export const getInvitationStatus = invite => {
  const expiredInvite = isExpired(invite.expires);
  // invitation revoked
  if (invite.revoked) {
    return { status: 'revoked', variant: 'error' };
  }
  // invitation expired
  if (expiredInvite) {
    return { status: 'expired', variant: 'error' };
  }
  // invitation pending
  if (invite.decision === null && !expiredInvite) {
    return { status: 'pending', variant: 'info' };
  }
  // invitation accepted
  if (invite.decision === true) {
    return { status: 'accepted', variant: 'success' };
  }
  // invitation declined
  if (invite.decision === false) {
    return { status: 'declined', variant: 'warning' };
  }
  return { status: 'unknown', variant: '' };
};
